var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{class:_vm.iconClass,attrs:{"icon":_vm.icon,"size":_vm.fieldConfig.iconSize}})}
var staticRenderFns = []

export { render, staticRenderFns }